export function convertBooleanToYesOrNo(val, t) {
    return val ? t('common.yes') : t('common.no');
}
